import { SHARE_BASE_URL } from "../../lib/constants"
import ShareIcon from '@mui/icons-material/Share';
import Fab from '@mui/material/Fab';
import { useNotify } from 'react-admin';

const generateSharableLink = (id:string, type: 'actual' | 'agenda') => {
  return `${SHARE_BASE_URL}/links/${type}/${id}`
}

interface Props {
  id:string
  type: 'actual' | 'agenda'
  copiedText: string
}

const fabGreenStyle = {
  color: 'common.black',
  marginTop: '7px',
  bgcolor: '#FFF',
  BorderColor: '#000',
  '&:hover': {
    bgcolor: '#FFF',
  },
};

const SharableLinkButton = (props: Props) => {
  const notify = useNotify();
  return (
    <Fab sx={fabGreenStyle} size="small">
      <ShareIcon onClick={() => {
        navigator.clipboard.writeText(generateSharableLink(props.id, props.type))

        notify(props.copiedText, { type: 'success' });
      }} />
    </Fab>
  )
  // return (
  //   <a onClick={() => {
  //     navigator.clipboard.writeText(generateSharableLink(props.id, props.type))

  //     notify('The sharable link is now on your clipboard.', { type: 'success' });
  //   }}>
  //     <ShareIcon />
  //   </a>)
}

export default SharableLinkButton